/* v2-finder-v2: トップ診断（常時展開・結果の保持・複数カート・モーダル詳細）
   設問: snippets/v2-finder-data-top（questions / weights。products は人手の「推し」タグ・理由文として上乗せにだけ使う）
   候補: sections/v2-finder-pool を診断開始時に取得（カテゴリ別コレクションの売れ筋上位・在庫ありのみ → 新製品は自動で入り、売り切れは外れる）
   推薦: 製品名の仕様（mAh / W / Wh・キーワード）とカテゴリ内の価格帯から、場面・重視点への合い方を 0〜1 で推定
         → 合い方（答えとの一致）+ 事前分布（カテゴリ内売れ筋・新製品・値下げ）でスコア
         → 1 位は最も合うものに固定、2 位は上位から温度付き抽選（同カテゴリは減点）、3 位は別カテゴリの「新しい発見」枠
         → 見せた製品は端末に記憶して次回は少し下げる（毎回ちがう発見）。カートに入っている製品は出さない
   ツリー（9/30〜）: data-tree（assets/v2-finder-tree.json）があれば、1 問目 → 2 問目 → 3 問目を答えに応じて出し分け、
         答えの組み合わせごとに決めた順（シート「確定案」の規則で並べたもの）から在庫あり・カート外の上位 3 つを出す。
         JSON は top-finder-mock/logic0929/build_tree.py が作る。無いときは従来の推定スコア
   保持: localStorage 'v2finder3:<category>' = { answers, picks, variants, ts }（7 日）/ 'v2finder2:seen' = { handle: [回数, 最終時刻] } */
(function () {
  if (window.v2FinderV2) return;

  var TTL = 7 * 24 * 60 * 60 * 1000;
  var RANK = ['いちばんのおすすめ', 'こちらもおすすめ', '新しい発見'];

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function yen(n) { return '¥' + Math.round(n / 100).toLocaleString('ja-JP'); }
  /* 発送予定（製品詳細ページ snippets/products-js.liquid の deliveryDateText と同じ計算） */
  function shipText(d) {
    var add = { '翌日': 1, '3日後': 3, '5日後': 5, '7日後': 7 }[d] || 0;
    var t = new Date(); t.setDate(t.getDate() + add);
    return (t.getMonth() + 1) + '月' + t.getDate() + '日 ' + '日月火水木金土'.charAt(t.getDay()) + '曜日までに発送予定';
  }
  var ANIM = {
    battery: '<svg viewBox="0 0 64 64" aria-hidden="true"><rect class="a-body" x="8" y="20" width="42" height="24" rx="5"/><rect class="a-cap" x="52" y="27" width="5" height="10" rx="1.5"/><rect class="a-cell a-cell1" x="13" y="25" width="9" height="14" rx="2"/><rect class="a-cell a-cell2" x="24.5" y="25" width="9" height="14" rx="2"/><rect class="a-cell a-cell3" x="36" y="25" width="9" height="14" rx="2"/><path class="a-bolt" d="M34 8 26 22h7l-2 12 9-15h-7l1-11z"/></svg>',
    plug: '<svg viewBox="0 0 64 64" aria-hidden="true"><g class="a-plug"><path d="M24 10v10M40 10v10"/><path d="M16 20h32v10a16 16 0 0 1-32 0V20z"/><path class="a-cord" d="M32 46v12"/></g><g class="a-spark"><path d="M8 26l4 2M8 34l4-2M56 26l-4 2M56 34l-4-2"/></g></svg>',
    power: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-bolt-big" d="M36 6 16 36h14l-4 22 22-30H34l2-22z"/><g class="a-rays"><path d="M10 14l6 4M54 14l-6 4M6 40l7-1M58 40l-7-1"/></g></svg>',
    house: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-roof" d="M8 32 32 10l24 22"/><path d="M14 27v26h36V27"/><path class="a-door" d="M27 53V38h10v15"/><g class="a-smoke"><circle cx="44" cy="12" r="2.5"/><circle cx="46" cy="6" r="2"/></g><path class="a-win" d="M20 33h6v6h-6zM38 33h6v6h-6z"/></svg>',
    headphones: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-band" d="M12 38V32a20 20 0 0 1 40 0v6"/><rect class="a-ear a-earL" x="9" y="36" width="11" height="17" rx="4"/><rect class="a-ear a-earR" x="44" y="36" width="11" height="17" rx="4"/><g class="a-notes"><path d="M27 20v-6l7-2v6"/><circle cx="25" cy="21" r="2"/><circle cx="32" cy="19" r="2"/></g></svg>',
    bag: '<svg viewBox="0 0 64 64" aria-hidden="true"><g class="a-bag"><path d="M12 22h40l-3 32H15l-3-32z"/><path class="a-handle" d="M23 22v-4a9 9 0 0 1 18 0v4"/><path class="a-zip" d="M20 32h24"/></g></svg>',
    desk: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M6 30h52"/><path d="M12 30v22M52 30v22"/><rect class="a-screen" x="20" y="10" width="24" height="16" rx="2"/><path d="M32 26v4"/><g class="a-cup"><path d="M44 42h8v8a4 4 0 0 1-8 0v-8z"/><path class="a-steam" d="M46 38v-3M50 38v-3"/></g></svg>',
    people: '<svg viewBox="0 0 64 64" aria-hidden="true"><g class="a-p1"><circle cx="24" cy="20" r="7"/><path d="M8 52a16 16 0 0 1 32 0"/></g><g class="a-p2"><circle cx="46" cy="24" r="6"/><path d="M38 52a12 12 0 0 1 20-8"/></g><path class="a-heart" d="M50 10c2-3 6-2 6 1 0 3-6 6-6 6s-6-3-6-6c0-3 4-4 6-1z"/></svg>',
    tent: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-tent" d="M32 12 6 54h52L32 12z"/><path d="M32 12v42"/><path d="M22 54l10-20 10 20"/><g class="a-star"><path d="M50 10l1.5 3 3 .5-2.2 2.2.5 3.3-2.8-1.6-2.8 1.6.5-3.3L45.5 13.5l3-.5z"/></g></svg>',
    feather: '<svg viewBox="0 0 64 64" aria-hidden="true"><g class="a-feather"><path d="M52 10c-14 0-28 10-34 26L10 56"/><path d="M52 10c0 14-10 28-26 34H18"/><path d="M38 24 20 42"/></g></svg>',
    bolt: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-bolt-big" d="M36 6 16 36h14l-4 22 22-30H34l2-22z"/><circle class="a-ring" cx="32" cy="32" r="26"/></svg>',
    tag: '<svg viewBox="0 0 64 64" aria-hidden="true"><g class="a-tag"><path d="M10 34V10h24l22 22-24 24-22-22z"/><circle cx="21" cy="21" r="3.5"/></g><path class="a-pct" d="M40 24l-8 8"/></svg>',
    sparkle: '<svg viewBox="0 0 64 64" aria-hidden="true"><path class="a-sp a-sp1" d="M32 8c0 10 6 16 16 16-10 0-16 6-16 16 0-10-6-16-16-16 10 0 16-6 16-16z"/><path class="a-sp a-sp2" d="M50 40c0 5 3 8 8 8-5 0-8 3-8 8 0-5-3-8-8-8 5 0 8-3 8-8z"/><path class="a-sp a-sp3" d="M14 44c0 4 2 6 6 6-4 0-6 2-6 6 0-4-2-6-6-6 4 0 6-2 6-6z"/></svg>'
  };

  /* 見た目の型: game（従来の黒ステージ）/ sentence（文章で答える）/ search（検索窓）。?fx_style= で一時切替（比較用） */
  var STYLES = ['game', 'sentence', 'search'];
  var COPY = {
    need: { lead: 'いま気になっているのは、', ask: 'いま困っていることは？', cap: 'よくある困りごと' },
    need_tree: { lead: 'やりたいのは、', ask: 'やりたいことは？', cap: '' },
    scene: { lead: 'おもに使うのは、', ask: 'どこで使いますか？', cap: 'よく使う場面' },
    priority: { lead: 'いちばん大事なのは、', ask: 'いちばん大事なのは？', cap: 'よく選ばれる決め手' }
  };

  function icon(name) {
    return '<span class="fx__opt-icon"><svg aria-hidden="true"><use href="#fx-' + name + '"></use></svg></span>';
  }
  function load(key) { try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function save(key, v) { try { window.localStorage.setItem(key, JSON.stringify(v)); } catch (e) {} }
  function drop(key) { try { window.localStorage.removeItem(key); } catch (e) {} }

  function init(root) {
    if (!root || root.__fx) return;
    root.__fx = true;
    root.__fxApi = {};
    var dataEl = root.querySelector('[data-finder-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var KEY = 'v2finder3:' + data.category; // 10/6 分岐の作り直しで v3 に（前の分岐の保存結果は使わない）
    try {
      var qs = new URLSearchParams(window.location.search).get('fx_style');
      if (STYLES.indexOf(qs) > -1) root.setAttribute('data-fx-style', qs);
    } catch (e) {}
    var style = root.getAttribute('data-fx-style') || 'game';
    var qWrap = root.querySelector('[data-fx-questions]');
    var result = root.querySelector('[data-fx-result]');
    var cardsWrap = root.querySelector('[data-fx-cards]');
    var picksEl = root.querySelector('[data-fx-picks]');
    var lead = root.querySelector('[data-fx-lead]');
    var progress = root.querySelector('[data-fx-progress]');
    var stepEl = root.querySelector('[data-fx-step]');
    var allBox = root.querySelector('[data-fx-all]');
    var countEl = root.querySelector('[data-fx-count]');
    var totalEl = root.querySelector('[data-fx-total]');
    var addAll = root.querySelector('[data-fx-addall]');
    var toast = root.querySelector('[data-fx-toast]');
    var modal = root.querySelector('[data-fx-modal]');
    /* .page-container に transform があり、fixed が画面基準にならないので body 直下へ移す */
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    if (toast && toast.parentNode !== document.body) document.body.appendChild(toast);
    var zoomEl = root.querySelector('[data-fx-zoom]');
    if (zoomEl && zoomEl.parentNode !== document.body) document.body.appendChild(zoomEl);

    var cards = {};
    var products = [];
    var byHandle = {};
    var curated = {};
    (data.products || []).forEach(function (p) { curated[p.handle] = p; });
    /* 候補プールはページ（DOM）には入れず、切り離した入れ物に保持する（非表示でも 1,400 要素ぶんスタイル計算の対象になっていた） */
    var poolEl = document.createElement('div');
    var questions = data.questions;
    var weights = data.weights || {};
    var answers = {};
    var current = 0;
    var shown = [];
    var picked = {};
    var variants = {};
    var restoredNote = false;
    /* ツリー（1 問目 → 2 問目 → 3 問目の出し分けと、答えごとの製品の順） */
    var treeUrl = root.getAttribute('data-tree');
    var TREE = null, treeState = 0, treeWaiters = [];
    function ensureTree(cb) {
      if (!treeUrl || treeState === 2) { if (cb) cb(); return; }
      if (cb) treeWaiters.push(cb);
      if (treeState === 1) return;
      treeState = 1;
      var done = function () { treeState = 2; treeWaiters.splice(0).forEach(function (f) { f(); }); };
      fetch(treeUrl).then(function (r) { return r.json(); }).then(function (j) { TREE = j; }).catch(function () {}).then(done, done);
    }
    /* 2 問目を聞かない 1 問目（10/9 「いつでもきれいな床にしたい」: 1 問目 → 3 問目）。ツリー側で skip を付けた選択肢を自動で選ぶ */
    function sceneSkipped() { return !!(TREE && answers.need && TREE.q2[answers.need] && TREE.q2[answers.need].skip); }
    function autoScene() {
      var o = TREE.q2[answers.need].options[0];
      if (answers.scene !== o.id) { answers.scene = o.id; delete answers.priority; rebuildTreeQ('priority'); }
    }
    function treeOpts(qid) {
      if (!TREE) return null;
      if (qid === 'need') return TREE.q1;
      if (qid === 'scene') return answers.need && TREE.q2[answers.need] ? TREE.q2[answers.need].options : [];
      if (qid === 'priority') return answers.need && answers.scene ? TREE.q3[answers.need + '|' + answers.scene] || [] : [];
      return null;
    }

    /* ── 保持 ── */
    function persist() {
      save(KEY, { answers: answers, picks: Object.keys(picked).filter(function (h) { return picked[h]; }), variants: variants, ts: Date.now() });
    }
    function restore() {
      var s = load(KEY);
      if (!s || !s.answers || Date.now() - (s.ts || 0) > TTL) return false;
      var ok;
      if (TREE) {
        var a = s.answers;
        ok = !!(a.need && a.scene && a.priority && TREE.picks[a.need + '|' + a.scene + '|' + a.priority]);
      } else {
        ok = questions.every(function (q) {
          var v = s.answers[q.id];
          var opts = q.id === 'scene' && SCENE_SETS[s.answers.need] ? SCENE_SETS[s.answers.need].concat(q.options) : q.options;
          return v && opts.some(function (o) { return o.id === v; });
        });
      }
      if (!ok) return false;
      answers = s.answers;
      (s.picks || []).forEach(function (h) { picked[h] = true; });
      variants = s.variants || {};
      return true;
    }

    /* ── 候補プール: 診断を始めるころに取りに行く（トップの初期 HTML を軽く保つ） ── */
    var poolState = 0, poolWaiters = [], inCart = {}, labels = {};
    function ensurePool(cb) {
      if (poolState === 2) { if (cb) cb(); return; }
      if (cb) poolWaiters.push(cb);
      if (poolState === 1) return;
      poolState = 1;
      var done = function () { indexPool(); poolState = 2; poolWaiters.splice(0).forEach(function (f) { f(); }); };
      Promise.all([
        fetch('/?section_id=v2-finder-pool', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          Array.prototype.forEach.call(tmp.querySelectorAll('[data-fx-card]'), function (c) { poolEl.appendChild(c); });
        }),
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          (c.items || []).forEach(function (it) { inCart[it.handle] = true; });
        }).catch(function () {}),
        /* AI が説明文・仕様を読んで付けた場面/重視点の採点（assets/v2-finder-labels.json）。無い製品は自動推定だけ */
        root.getAttribute('data-labels') ? fetch(root.getAttribute('data-labels')).then(function (r) { return r.json(); }).then(function (j) { labels = (j && j.items) || {}; }).catch(function () {}) : null
      ]).then(done, done);
    }

    /* ── 製品の性質を推定（人手のタグが無くても新製品に効くよう、名前の仕様とカテゴリ内の位置から） ── */
    function num(re, t) { var m = t.match(re); return m ? parseFloat(m[1].replace(/,/g, '')) : 0; }
    function maxW(t) { var m = t.match(/(\d+(?:\.\d+)?)\s*W(?!h)/g) || []; return m.reduce(function (a, x) { return Math.max(a, parseFloat(x)); }, 0); }
    var RE_SMALL = /nano|slim|mini|\bgo\b|compact|pocket|lite|clip|flip|q2|soundcore c\d|dot/i;
    var RE_BIG = /pro\b|max|ultra|prime|omni|\bx\d{1,2}\b|4k|solix|\bs\d{3,4}\b|\bf\d{4}\b|c\d{3,4}\b|motion x|boom \d|cosmos/i;
    var RE_OUTDOOR = /outdoor|solar|ソーラー|屋外|防水|ip6\d|ip5\d|floodlight|camp|キャンプ|boom|motion|capsule|mars|battery|バッテリー内蔵|eufycam|s3\d0|e3\d0|c35/i;
    function clamp(x) { return Math.max(0, Math.min(1, x)); }
    function indexPool() {
      cards = {}; products = []; byHandle = {};
      var now = Date.now() / 1000;
      Array.prototype.forEach.call(poolEl.querySelectorAll('[data-fx-card]'), function (c) {
        var h = c.getAttribute('data-handle');
        if (cards[h]) return;
        cards[h] = c;
        var t = c.getAttribute('data-name') || '';
        var cur = curated[h] || {};
        var pts = (safeJSON(c.getAttribute('data-points')) || []).map(function (x) { return String(x).split('\n')[0].replace(/[※*]\d*$/, '').trim(); }).filter(Boolean);
        var p = {
          handle: h, title: t, cat: c.getAttribute('data-cat') || '', need: c.getAttribute('data-need') || '',
          crank: parseInt(c.getAttribute('data-crank'), 10) || 9,
          price: parseInt(c.getAttribute('data-price'), 10) || 0, cmp: parseInt(c.getAttribute('data-cmp'), 10) || 0,
          age: (now - (parseInt(c.getAttribute('data-created'), 10) || now)) / 86400,
          isNew: c.getAttribute('data-new') === 'true',
          mah: num(/([\d,]{4,6})\s*mAh/i, t), w: maxW(t), wh: num(/([\d,]{3,5})\s*Wh/i, t),
          tags: cur.tags || null, reason: cur.reason || '', points: cur.points && cur.points.length ? cur.points : pts
        };
        p.off = p.cmp > p.price ? (p.cmp - p.price) / p.cmp : 0;
        /* 仕様メタフィールド（入っていれば数値で）→ 無ければ名前から */
        var sp = safeJSON(c.getAttribute('data-spec')) || {};
        var get = function (k) { var v = sp[k]; return v && v !== '-' ? String(v) : ''; };
        var cap = get('capacity') + ' ' + get('battery_capacity');
        p.mah = num(/([\d,]{4,6})\s*mAh/i, cap) || p.mah;
        p.wh = num(/([\d,]{3,5})\s*Wh/i, cap) || p.wh;
        p.w = maxW(get('total_maximum_output')) || p.w;
        var wt = get('weight').match(/([\d.]+)\s*(kg|g)/i);
        p.g = wt ? parseFloat(wt[1]) * (/kg/i.test(wt[2]) ? 1000 : 1) : 0;
        var ip = get('waterproof_standard').match(/IP([\dX])(\d)/i);
        p.ipw = ip ? parseInt(ip[2], 10) : 0;
        p.ipStr = ip ? ip[0].toUpperCase() : '';
        p.anc = !!get('noise_cancelling');
        p.hours = (get('playable_time') + ' ' + get('continuous_playable_time')).match(/\d+(?=\s*時間)/g);
        p.hours = p.hours ? Math.max.apply(null, p.hours.map(Number)) : 0;
        p.lm = num(/([\d,]{2,5})\s*(?:ANSI)?\s*ルーメン/i, get('luminance'));
        p.res4k = /4K|3840|2160/i.test(get('resolution') + ' ' + t);
        p.pa = num(/([\d,]{3,5})\s*Pa/i, get('suction_power'));
        var ld = get('launch_date').match(/(\d{4})年\s*(\d{1,2})月/);
        p.launchMo = ld ? (new Date().getFullYear() - parseInt(ld[1], 10)) * 12 + (new Date().getMonth() + 1 - parseInt(ld[2], 10)) : null;
        p.rc = parseInt(sp.rc, 10) || 0;
        /* 発売から 3 年を超えた型は、売れ筋でも候補にしない（古い型が「発見」として出るのを防ぐ）。
           ただし診断ツリーに載っている製品（data-tree。レビューで差し替え先に選ばれた Q20i など）は残す */
        if (p.launchMo !== null && p.launchMo > 36 && !c.hasAttribute('data-tree')) { delete cards[h]; return; }
        p.text = (t + ' ' + (c.getAttribute('data-desc') || '') + ' ' + (c.getAttribute('data-tags') || '')).toLowerCase();
        p.tagNew = /(^|\s)new(\s|$)/.test(c.getAttribute('data-tags') || '');
        p.isNew = p.isNew || p.tagNew || (p.launchMo !== null && p.launchMo <= 4);
        /* カテゴリ内で比べる「強さ」: バッテリー=mAh / ポタ電=Wh / 充電系=W / プロジェクター=ルーメン / 掃除機=Pa / それ以外は価格 */
        p.spec = p.cat === 'モバイルバッテリー' ? p.mah : p.cat === 'ポータブル電源' ? (p.wh || p.price) : /充電器|ケーブル|USBハブ/.test(p.cat) && p.w ? p.w
          : p.cat === 'プロジェクター' && p.lm ? p.lm : p.cat === 'ロボット掃除機' && p.pa ? p.pa : p.price;
        products.push(p);
        byHandle[h] = p;
      });
      /* カテゴリ内の相対位置（価格・仕様）: 0 = いちばん安い/小さい、1 = いちばん高い/大きい */
      var byCat = {};
      products.forEach(function (p) { (byCat[p.cat] = byCat[p.cat] || []).push(p); });
      Object.keys(byCat).forEach(function (k) {
        var a = byCat[k];
        var rel = function (key, prop) {
          var sorted = a.slice().sort(function (x, y) { return x[key] - y[key]; });
          sorted.forEach(function (p, i) { p[prop] = sorted.length > 1 ? i / (sorted.length - 1) : 0.5; });
        };
        rel('price', 'pp'); rel('spec', 'sp');
        var withG = a.filter(function (p) { return p.g; });
        if (withG.length > 2) {
          var sg = withG.slice().sort(function (x, y) { return x.g - y.g; });
          sg.forEach(function (p, i) { p.gp = i / (sg.length - 1); });
        }
      });
      products.forEach(function (p) { p.feat = features(p); });
    }
    /* 説明文・タグ・名前から拾う手がかり（ヒット数で 0〜1） */
    var CUE = {
      scene: {
        out: /持ち運|持ち歩|外出|通勤|通学|旅行|出張|ポケット|カバン|goout|モバイル|移動/,
        home: /デスク|テレワーク|在宅|deskwork|ノートpc|パソコン|macbook|会議|ドッキング|作業/,
        family: /リビング|家族|ペット|お部屋|部屋|ホームシアター|livingalone|一人暮らし|寝室|テレビ|留守|見守/,
        outdoor: /アウトドア|キャンプ|屋外|ソーラー|bbq|庭|車中泊|防災|停電|災害|お風呂|海|プール/
      },
      pri: {
        light: /小型|コンパクト|軽量|薄型|ミニ|手のひら|ポケット|最小|最軽量|スリム/,
        power: /最高|大容量|高出力|急速|ハイレゾ|ldac|dolby|4k|史上最|フラッグシップ|パワフル|圧倒的|最大クラス|ノイズキャンセリング/,
        value: /お手頃|コスパ|手頃|エントリー|定番|リーズナブル|手軽/,
        new: /新登場|新製品|最新|次世代|進化/
      }
    };
    function cue(re, text) { var m = text.match(new RegExp(re.source, 'g')); return m ? Math.min(1, m.length * 0.34) : 0; }
    function features(p) {
      var t = p.title, small = RE_SMALL.test(t), big = RE_BIG.test(t), outd = RE_OUTDOOR.test(t) || p.ipw >= 5;
      var sc = { out: 0.2, home: 0.3, family: 0.2, outdoor: 0.1 };
      switch (p.cat) {
        case 'モバイルバッテリー': sc = { out: 1 - p.sp * 0.4, home: 0.3, family: 0.25, outdoor: 0.3 + p.sp * 0.6 }; break;
        case '充電器': sc = { out: p.w && p.w <= 45 ? 0.75 : 0.35, home: p.w >= 65 ? 0.95 : 0.7, family: 0.3, outdoor: 0.1 }; break;
        case 'ケーブル': sc = { out: 0.75, home: 0.75, family: 0.3, outdoor: 0.15 }; break;
        case 'USBハブ': sc = { out: small ? 0.6 : 0.35, home: 0.95, family: 0.15, outdoor: 0.05 }; break;
        case 'ポータブル電源': sc = { out: 0.15 + (1 - p.sp) * 0.35, home: 0.3, family: 0.7, outdoor: 0.95 }; break;
        case 'セキュリティ': sc = { out: 0.05, home: 0.45, family: 0.85, outdoor: outd ? 0.85 : 0.3 }; break;
        case 'ロボット掃除機': sc = { out: 0, home: 0.5, family: 0.95, outdoor: 0 }; break;
        case 'イヤホン': sc = { out: 0.95, home: 0.5, family: 0.3, outdoor: p.ipw >= 5 ? 0.6 : 0.3 }; break;
        case 'ヘッドホン': sc = { out: 0.6, home: 0.8, family: 0.4, outdoor: 0.2 }; break;
        case 'スピーカー': sc = { out: small ? 0.55 : 0.25, home: 0.5, family: 0.75, outdoor: outd || small ? 0.85 : 0.45 }; break;
        case 'プロジェクター': sc = { out: 0.15, home: 0.65, family: 0.9, outdoor: outd ? 0.75 : 0.3 }; break;
      }
      /* カテゴリの型 6 割 + 説明文・タグの手がかり 4 割 */
      Object.keys(sc).forEach(function (k) { sc[k] = clamp(sc[k] * 0.75 + cue(CUE.scene[k], p.text) * 0.4); });
      var lightness = p.gp != null ? 1 - p.gp : 1 - p.sp;
      var pr = {
        light: clamp(lightness * 0.55 + (small ? 0.3 : 0) + cue(CUE.pri.light, p.text) * 0.3 - (big ? 0.2 : 0)),
        power: clamp(p.sp * 0.45 + p.pp * 0.2 + (big ? 0.25 : 0) + (p.anc ? 0.1 : 0) + (p.res4k ? 0.1 : 0) + cue(CUE.pri.power, p.text) * 0.3 - (small ? 0.1 : 0)),
        value: clamp((1 - p.pp) * 0.6 + Math.min(1, p.off * 3) * 0.35 + cue(CUE.pri.value, p.text) * 0.2 + Math.min(0.15, p.rc / 600)),
        new: p.isNew ? 1 : p.launchMo !== null ? (p.launchMo <= 8 ? 0.75 : p.launchMo <= 14 ? 0.45 : 0.12) : (p.age < 120 ? 0.8 : p.age < 365 ? 0.45 : 0.1)
      };
      pr.new = clamp(pr.new + cue(CUE.pri.new, p.text) * 0.15);
      /* AI の採点があれば 7 割それを信じる（新しさは日付で決まるので自動推定のまま） */
      var L = labels[p.handle];
      if (L) {
        Object.keys(sc).forEach(function (k) { if (L.s && L.s[k] != null) sc[k] = clamp(L.s[k] * 0.7 + sc[k] * 0.3); });
        ['light', 'power', 'value'].forEach(function (k) { if (L.p && L.p[k] != null) pr[k] = clamp(L.p[k] * 0.7 + pr[k] * 0.3); });
        p.why = L.why || '';
      }
      /* 人手の「推し」タグは強い根拠として底上げ */
      if (p.tags) {
        (p.tags.scene || []).forEach(function (k) { sc[k] = Math.max(sc[k] || 0, 1); });
        (p.tags.priority || []).forEach(function (k) { pr[k] = Math.max(pr[k] || 0, 1); });
      }
      return { scene: sc, pri: pr };
    }
    /* ── 場面の質問: 1 問目（困りごと）に合わせて選択肢を出し分ける ──
       m = 既存の 4 場面（out 持ち歩き / home デスク / family リビング / outdoor 庭・キャンプ）の重み。合う候補が 2 つ未満の場面は隠す */
    var SCENE_SETS = {
      battery: [
        { id: 'commute', label: '通勤・通学', icon: 'bag', m: { out: 1 } },
        { id: 'travel', label: '旅行・出張', icon: 'tent', m: { out: 0.7, outdoor: 0.3 } },
        { id: 'desk', label: 'デスク', icon: 'desk', m: { home: 1 } },
        { id: 'prep', label: 'もしもの備えにも', icon: 'power', m: { outdoor: 0.6, family: 0.4 } }
      ],
      tidy: [
        { id: 'desk', label: 'デスク', icon: 'desk', m: { home: 1 } },
        { id: 'go', label: '外出・旅行', icon: 'bag', m: { out: 1 } },
        { id: 'room', label: 'リビング・寝室', icon: 'house', m: { family: 1 } },
        { id: 'car', label: '車の中', icon: 'tent', m: { out: 0.6, outdoor: 0.4 } }
      ],
      outage: [
        { id: 'inhome', label: '家の中', icon: 'house', m: { family: 1 } },
        { id: 'camp', label: 'キャンプ・車中泊', icon: 'tent', m: { outdoor: 1 } },
        { id: 'wfh', label: '在宅ワーク', icon: 'desk', m: { home: 0.7, family: 0.3 } },
        { id: 'grab', label: '持ち出し用', icon: 'bag', m: { out: 0.6, outdoor: 0.4 } }
      ],
      home: [
        { id: 'living', label: 'リビング', icon: 'house', m: { family: 1 } },
        { id: 'entrance', label: '玄関・屋外', icon: 'tent', m: { outdoor: 1 } },
        { id: 'away', label: '留守中の見守り', icon: 'people', m: { family: 0.6, outdoor: 0.4 } }
      ],
      enjoy: [
        { id: 'commute', label: '通勤・移動', icon: 'bag', m: { out: 1 } },
        { id: 'relax', label: '自宅でゆっくり', icon: 'house', m: { family: 0.7, home: 0.3 } },
        { id: 'work', label: '作業・勉強中', icon: 'desk', m: { home: 1 } },
        { id: 'outdoor', label: 'アウトドア・お風呂', icon: 'tent', m: { outdoor: 1 } }
      ]
    };
    var sceneQ = questions.filter(function (q) { return q.id === 'scene'; })[0];
    var baseSceneOpts = sceneQ ? sceneQ.options.slice() : [];
    var sceneOpts = baseSceneOpts;
    function sceneDef(id) { return sceneOpts.filter(function (o) { return o.id === id; })[0] || baseSceneOpts.filter(function (o) { return o.id === id; })[0]; }
    function sceneAff(p, id) {
      var d = sceneDef(id);
      if (!d || !d.m) return p.feat.scene[id] || 0;
      var s2 = 0, w = 0;
      Object.keys(d.m).forEach(function (k) { s2 += d.m[k] * (p.feat.scene[k] || 0); w += d.m[k]; });
      return w ? s2 / w : 0;
    }
    /* ツリー: 2 問目・3 問目の選択肢と問いの文を、前の答えに合わせて作り直す */
    function rebuildTreeQ(qid) {
      var panel = qWrap.querySelector('.fx__q[data-q="' + qid + '"]');
      var q = questions.filter(function (x) { return x.id === qid; })[0];
      if (!panel || !q) return;
      var list = treeOpts(qid) || [];
      var ask = (qid === 'scene' || (qid === 'priority' && sceneSkipped())) && TREE.q2[answers.need] ? TREE.q2[answers.need].ask : (COPY[qid] || {}).ask || q.title;
      var t = panel.querySelector('.fx__q-title'); if (t) t.textContent = ask;
      var ld = panel.querySelector('.fx__q-lead'); if (ld) ld.textContent = qid === 'scene' ? ask : (COPY[qid] || {}).lead || ask;
      var ak = panel.querySelector('[data-fx-ask]'); if (ak) ak.textContent = ask;
      var opts = panel.querySelector('.fx__opts');
      opts.innerHTML = '';
      opts.setAttribute('data-count', list.length);
      list.forEach(function (o) { var b = makeOpt(q, o, opts.children.length); if (answers[qid] === o.id) b.classList.add('is-on'); opts.appendChild(b); });
      if (answers[qid] && !list.some(function (o) { return o.id === answers[qid]; })) delete answers[qid];
    }
    function rebuildScene() {
      if (TREE) { rebuildTreeQ('scene'); rebuildTreeQ('priority'); return; }
      if (!sceneQ) return;
      var set = SCENE_SETS[answers.need];
      var list = set ? set.slice() : baseSceneOpts.slice();
      /* 合う候補（困りごとが同じ or 近い × 場面の合い方 0.55 以上）が 2 つ未満の場面は出さない */
      if (poolState === 2 && set) {
        var keep = list.filter(function (o) {
          var n = 0;
          products.forEach(function (p) {
            var near = p.need === answers.need || ((NEAR[answers.need] || {})[p.need] || 0) > 0;
            if (!near) return;
            var s2 = 0, w = 0; Object.keys(o.m).forEach(function (k) { s2 += o.m[k] * (p.feat.scene[k] || 0); w += o.m[k]; });
            if (s2 / w >= 0.55) n++;
          });
          return n >= 2;
        });
        if (keep.length >= 2) list = keep;
      }
      sceneOpts = list;
      var panel = qWrap.querySelector('.fx__q[data-q="scene"]');
      if (!panel) return;
      var opts = panel.querySelector('.fx__opts');
      opts.innerHTML = '';
      opts.setAttribute('data-count', list.length);
      list.forEach(function (o) { var b = makeOpt(sceneQ, o, opts.children.length); if (answers.scene === o.id) b.classList.add('is-on'); opts.appendChild(b); });
      if (answers.scene && !sceneDef(answers.scene)) delete answers.scene;
    }

    /* 困りごと同士の近さ（充電器は「電池が切れる」にも効く、など） */
    var NEAR = { battery: { tidy: 0.35, outage: 0.12 }, tidy: { battery: 0.3 }, outage: { battery: 0.45 }, home: { outage: 0.15 }, enjoy: {} };

    /* ── スコア ── */
    function fit(p) {
      var s = 0, w = 0;
      questions.forEach(function (q) {
        var a = answers[q.id];
        if (!a) return;
        var k = weights[q.id] || 1;
        var v = q.id === 'need' ? (p.need === a ? 1 : ((NEAR[a] || {})[p.need] || 0))
          : q.id === 'scene' ? sceneAff(p, a) : (p.feat.pri[a] || 0);
        s += k * v; w += k;
      });
      return w ? s / w : 0;
    }
    function prior(p) { return 0.45 * (1 - (p.crank - 1) / 8) + 0.2 * Math.min(1, Math.log10(p.rc + 1) / 2) + 0.2 * (p.isNew ? 1 : 0) + 0.15 * Math.min(1, p.off * 3); }
    function score(p) { return fit(p) * 0.9 + prior(p) * 0.1; }

    /* 端末ごとの「もう見た」記憶: 見せた回数だけ少し下げる（14 日で忘れる） */
    var SEEN_KEY = 'v2finder2:seen';
    function seenMap() { var m = load(SEEN_KEY) || {}; var lim = Date.now() - 14 * 864e5; Object.keys(m).forEach(function (h) { if (!m[h] || m[h][1] < lim) delete m[h]; }); return m; }
    function markSeen(list) { var m = seenMap(); list.forEach(function (p) { var e = m[p.handle] || [0, 0]; m[p.handle] = [e[0] + 1, Date.now()]; }); save(SEEN_KEY, m); }
    function novelty(p, m) { var e = m[p.handle]; return e ? Math.min(0.12, e[0] * 0.04) : 0; }

    function rank() {
      return products.filter(function (p) { return !inCart[p.handle]; })
        .map(function (p) { return { p: p, s: score(p) }; })
        .sort(function (a, b) { return b.s - a.s || a.p.crank - b.p.crank; })
        .map(function (r) { return r.p; });
    }
    function sample(list, T) {
      if (!list.length) return null;
      var mx = Math.max.apply(null, list.map(function (x) { return x.s; }));
      var ws = list.map(function (x) { return Math.exp((x.s - mx) / T); });
      var sum = ws.reduce(function (a, b) { return a + b; }, 0), r = Math.random() * sum;
      for (var i = 0; i < list.length; i++) { r -= ws[i]; if (r <= 0) return list[i]; }
      return list[list.length - 1];
    }
    /* 3 つを選ぶ: 1 位は固定（いちばん合う）/ 2 位は上位からゆらぎ付き / 3 位は別カテゴリの発見枠 */
    /* 「ほかの候補も見る」は、同じ答えの順の続きから 3 つ（最後まで行ったら先頭に戻る） */
    var treeOffset = 0;
    function treeList() {
      var k2 = answers.need + '|' + answers.scene;
      var order = (TREE.picks[k2 + '|' + answers.priority] || []).concat(TREE.cands[k2] || []);
      var list = [], used = {};
      order.forEach(function (h) {
        var p = byHandle[h];
        if (!p || used[h] || inCart[h]) return;
        used[h] = true; list.push(p);
      });
      return list;
    }
    function treePick(n) {
      var list = treeList();
      /* 10/8: 「ほかの候補も見る」は 3 件の組ごと入れ替える（同じ製品を残さない）。組がそろわない端数は使わない */
      var pages = Math.floor(list.length / n);
      if (pages < 2) return list.slice(0, n);
      var start = (treeOffset % pages) * n;
      return list.slice(start, start + n);
    }
    function pick3() {
      if (TREE) return treePick(3);
      var m = seenMap();
      var all = products.filter(function (p) { return !inCart[p.handle]; }).map(function (p) { return { p: p, f: fit(p), s: score(p) }; })
        .sort(function (a, b) { return b.s - a.s || a.p.crank - b.p.crank; });
      if (!all.length) return [];
      var out = [all[0]];
      var used = {}; used[all[0].p.handle] = true;
      var rest = all.filter(function (x) { return !used[x.p.handle]; });
      /* 2 位は 1 位に近い合い方（75% 以上）の中からだけ選ぶ */
      var near2 = rest.filter(function (x) { return x.f >= all[0].f * 0.75; });
      var c2 = (near2.length ? near2 : rest).slice(0, 8).map(function (x) { return { p: x.p, f: x.f, s: x.s - novelty(x.p, m) - (x.p.cat === all[0].p.cat ? 0.05 : 0) }; });
      var two = sample(c2, 0.045);
      if (two) { out.push(two); used[two.p.handle] = true; }
      /* 表示のマッチ度が 1 位 < 2 位にならないよう、合い方の高い方を 1 位に */
      if (two && two.f > out[0].f) out.reverse();
      var cats = {}; out.forEach(function (x) { cats[x.p.cat] = true; });
      var floor = Math.max(0.45, out[0].f * 0.6);
      var nearOk = function (p) { return p.need === answers.need || ((NEAR[answers.need] || {})[p.need] || 0) > 0; };
      var c3 = all.filter(function (x) { return !used[x.p.handle] && !cats[x.p.cat] && x.f >= floor && nearOk(x.p); })
        .slice(0, 10).map(function (x) { return { p: x.p, f: x.f, s: x.s - novelty(x.p, m) + (x.p.isNew ? 0.04 : 0) + Math.min(0.04, x.p.off * 0.2) }; });
      if (!c3.length) c3 = all.filter(function (x) { return !used[x.p.handle] && nearOk(x.p); }).slice(0, 6);
      if (!c3.length) c3 = all.filter(function (x) { return !used[x.p.handle]; }).slice(0, 6);
      var three = sample(c3, 0.06);
      if (three) out.push(three);
      return out.map(function (x) { return x.p; });
    }
    function matchPct(p) { return Math.max(40, Math.min(99, Math.round(fit(p) * 100))); }

    /* 理由: 人手の文が答えと合っていればそれを、なければ答え × 仕様から組み立てる */
    function specText(p) {
      var a = [];
      if (p.mah) a.push(p.mah.toLocaleString('ja-JP') + 'mAh');
      if (p.wh) a.push(p.wh.toLocaleString('ja-JP') + 'Wh');
      if (p.w && !p.wh) a.push('最大' + p.w + 'W');
      if (p.anc) a.push('ノイズキャンセリング');
      if (p.ipw >= 4) a.push('防水 ' + p.ipStr);
      if (p.hours) a.push('最大' + p.hours + '時間再生');
      if (p.lm) a.push(p.lm + 'ルーメン');
      if (p.pa) a.push('吸引力' + p.pa + 'Pa');
      if (p.g && p.g < 1000 && p.cat !== 'イヤホン') a.push('約' + Math.round(p.g) + 'g');
      a = a.slice(0, 3);
      return a.join('・');
    }
    var SCENE_JP = { out: '持ち歩き', home: 'デスク', family: 'リビング', outdoor: '庭やキャンプ' };
    var PRI_JP = { light: '小さく手軽', power: '性能重視', value: '手の届く価格', new: '新しいデザイン' };
    function reasonFor(p) {
      if (TREE) {
        /* 10/8 スプシの指示: 製品ごとの紹介文があればそれを出す（床掃除など） */
        if (TREE.reason && TREE.reason[p.handle]) return TREE.reason[p.handle];
        var sp0 = specText(p), pr0 = optionLabel('priority', answers.priority);
        return (pr0 ? '「' + pr0.replace(/[（(].*$/, '') + '」で選ぶなら。' : '') + (sp0 ? sp0 + '。' : '');
      }
      if (p.reason && (!p.tags || (p.tags.need || []).indexOf(answers.need) > -1)) return p.reason;
      if (p.why) return p.why + (p.need !== answers.need ? '「' + optionLabel('need', answers.need) + '」にも別の角度から効きます。' : '');
      var sp = specText(p), sc = answers.scene && (SCENE_JP[answers.scene] || (sceneDef(answers.scene) || {}).label), pr = answers.priority && PRI_JP[answers.priority];
      var head = (sc ? sc + 'にちょうどいい' : '') + (pr ? (sc ? '、' : '') + pr + 'の' : '') + p.cat + '。';
      return head + (sp ? sp + '。' : '') + (p.need !== answers.need ? '「' + optionLabel('need', answers.need) + '」の悩みにも別の角度から効きます。' : '');
    }
    function tagsFor(p) {
      var t = [];
      /* 10/8: 「◯◯ 売れ筋 N 位」はトップのランキングの順位と食い違うことがあるので出さない（スプシの指示） */
      if (p.isNew || p.age < 120) t.push('新製品');
      /* 10/15: 割引率は価格の横（product-price-v2 と同じ赤い札）に出ているので、タグでは出さない（重複） */
      return t.map(function (x) { return '<span>' + x + '</span>'; }).join('');
    }
    function optionLabel(qid, val) {
      var tl = treeOpts(qid);
      if (tl) { var to = tl.filter(function (o) { return o.id === val; })[0]; if (to) return to.label; }
      if (qid === 'scene') { var d = sceneDef(val); if (d) return d.label; }
      var q = questions.filter(function (x) { return x.id === qid; })[0];
      var o = q && q.options.filter(function (x) { return x.id === val; })[0];
      return o ? o.label : '';
    }

    /* ── 設問 ── */
    function makeOpt(q, o, k) {
      var name = o.icon === 'house' && o.id === 'home' && q.id === 'scene' ? 'desk' : o.icon;
      var src = '';
      var anim = ANIM[name] || ANIM.tag;
      var visual = '<span class="fx__opt-visual fx__opt-visual--anim" data-anim="' + name + '">' + anim + '</span>';
      var b = el('button', 'fx__opt fx__opt--photo fx__opt--anim', visual + icon(name) + '<span class="fx__opt-label">' + o.label + '</span><span class="fx__opt-check"><svg aria-hidden="true"><use href="#fx-check"></use></svg></span>');
      if (o.tint) b.style.setProperty('--tint', o.tint);
      if (style === 'game' && window.matchMedia('(hover: hover)').matches) {
        b.addEventListener('pointermove', function (ev) {
          var r = b.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          b.style.setProperty('--rx', (-py * 10).toFixed(2) + 'deg');
          b.style.setProperty('--ry', (px * 12).toFixed(2) + 'deg');
          b.style.setProperty('--tx', (px * 10).toFixed(1) + 'px');
          b.style.setProperty('--ty', (py * 10).toFixed(1) + 'px');
        });
        b.addEventListener('pointerleave', function () {
          ['--rx', '--ry', '--tx', '--ty'].forEach(function (k) { b.style.removeProperty(k); });
        });
      }
      b.type = 'button';
      b.setAttribute('data-q', q.id);
      b.setAttribute('data-val', o.id);
      b.style.setProperty('--k', String(k));
      return b;
    }
    function buildQuestions() {
      qWrap.innerHTML = '';
      questions.forEach(function (q, qi) {
        var panel = el('div', 'fx__q');
        panel.setAttribute('data-q', q.id);
        panel.hidden = qi !== 0;
        var qh = el('div', 'fx__q-head');
        qh.appendChild(el('span', 'fx__q-num', '0' + (qi + 1)));
        qh.appendChild(el('p', 'fx__q-title', q.title));
        panel.appendChild(qh);
        var cp = (treeUrl && COPY[q.id + '_tree']) || COPY[q.id] || { lead: q.title, ask: q.title, cap: '' };
        panel.appendChild(el('p', 'fx__q-lead', cp.lead));
        var ask = el('div', 'fx__ask', '<svg aria-hidden="true"><use href="#fx-sparkle"></use></svg><span class="fx__ask-text" data-fx-ask>' + cp.ask + '</span><span class="fx__ask-step">' + (qi + 1) + ' / ' + questions.length + '</span>');
        ask.setAttribute('aria-hidden', 'true');
        panel.appendChild(ask);
        if (cp.cap) panel.appendChild(el('p', 'fx__q-cap', cp.cap));
        var opts = el('div', 'fx__opts');
        opts.setAttribute('data-count', q.options.length);
        q.options.forEach(function (o) { opts.appendChild(makeOpt(q, o, opts.children.length)); });
        panel.appendChild(opts);
        if (qi > 0) {
          var back = el('button', 'fx__link fx__back', '<svg aria-hidden="true"><use href="#fx-arrow"></use></svg>前の質問に戻る');
          back.type = 'button';
          back.setAttribute('data-fx-back', '');
          panel.appendChild(back);
        }
        qWrap.appendChild(panel);
      });
    }
    function renderProgress(done) {
      var segs = progress.querySelectorAll('i');
      Array.prototype.forEach.call(segs, function (s, i) {
        s.classList.toggle('is-done', done || i < current);
        s.classList.toggle('is-current', !done && i === current);
      });
      var sk = sceneSkipped() && current > 1 ? 1 : 0;  /* 2 問目を飛ばした分岐は「2 / 2」と数える */
      stepEl.textContent = done ? '診断完了' : (current + 1 - sk) + ' / ' + (questions.length - (sceneSkipped() ? 1 : 0));
      if (progress.children[1]) progress.children[1].hidden = sceneSkipped();
    }
    function showPanel(idx) {
      current = idx;
      result.hidden = true;
      qWrap.hidden = false;
      root.classList.remove('is-done');
      Array.prototype.forEach.call(qWrap.children, function (p, i) {
        p.hidden = i !== idx;
        if (i === idx) {
          p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in');
          var a = p.querySelector('[data-fx-ask]'), q = questions[i];
          var stp = p.querySelector('.fx__ask-step');
          if (stp) { var skp = sceneSkipped() && i > 1 ? 1 : 0; stp.textContent = (i + 1 - skp) + ' / ' + (questions.length - (sceneSkipped() ? 1 : 0)); }
          if (a && q) { a.textContent = TREE && (q.id === 'scene' || (q.id === 'priority' && sceneSkipped())) && TREE.q2[answers.need] ? TREE.q2[answers.need].ask : ((treeUrl && COPY[q.id + '_tree']) || COPY[q.id] || {}).ask || q.title; a.parentNode.classList.remove('is-typed'); }
        }
      });
      if (lead) { lead.textContent = ''; lead.hidden = true; }
      renderProgress(false);
    }
    function onOption(btn) {
      treeOffset = 0;
      ensurePool();
      var qid = btn.getAttribute('data-q');
      if (qid === 'need' && answers.need !== btn.getAttribute('data-val')) {
        answers.need = btn.getAttribute('data-val'); delete answers.scene; delete answers.priority;
        if (treeUrl) ensureTree(rebuildScene); else { rebuildScene(); ensurePool(rebuildScene); }
      }
      if (qid === 'scene' && TREE && answers.scene !== btn.getAttribute('data-val')) { answers.scene = btn.getAttribute('data-val'); delete answers.priority; rebuildTreeQ('priority'); }
      answers[qid] = btn.getAttribute('data-val');
      Array.prototype.forEach.call(btn.parentNode.children, function (o) {
        o.classList.toggle('is-on', o === btn);
        o.classList.toggle('is-dim', o !== btn);
      });
      addTrail(qid, btn);
      if (current + 1 < questions.length) renderCands();
      var delay = 420;
      if (style === 'search') { typeAsk(btn); delay = 820; }
      if (style === 'sentence') delay = 700;
      window.setTimeout(function () {
        Array.prototype.forEach.call(btn.parentNode.children, function (o) { o.classList.remove('is-dim'); });
        var next = current + 1;
        if (questions[next] && questions[next].id === 'scene' && sceneSkipped()) { autoScene(); next++; }
        if (next < questions.length) showPanel(next);
        else showResult();
      }, delay);
    }
    /* 検索窓の型: 選んだ語を入力欄に打ち込む */
    function typeAsk(btn) {
      var box = btn.closest('.fx__q').querySelector('[data-fx-ask]');
      if (!box) return;
      var text = btn.querySelector('.fx__opt-label').textContent;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.parentNode.classList.add('is-typed');
      if (reduce) { box.textContent = text; return; }
      var i = 0;
      box.textContent = '';
      var iv = window.setInterval(function () {
        i++;
        box.textContent = text.slice(0, i);
        if (i >= text.length) window.clearInterval(iv);
      }, Math.max(24, Math.min(45, 420 / text.length)));
    }

    /* 答えた選択肢を上に「集めていく」 */
    var trail = root.querySelector('[data-fx-trail]');
    function addTrail(qid, btn) {
      if (!trail) return;
      var old = trail.querySelector('[data-trail="' + qid + '"]');
      if (old) old.remove();
      var im = btn.querySelector('img');
      var chip = el('span', 'fx__trail-chip', (im ? '<img src="' + im.src + '" alt="">' : '') + '<span>' + btn.querySelector('.fx__opt-label').textContent + '</span>');
      chip.setAttribute('data-trail', qid);
      trail.appendChild(chip);
      trail.hidden = false;
    }
    function clearTrail() { if (trail) { trail.innerHTML = ''; trail.hidden = true; } }

    /* ── 候補プレビュー: 2 問答えたあたりから、答えに合う製品を小さく並べ始める ── */
    var cands = root.querySelector('[data-fx-cands]');
    var candsRow = root.querySelector('[data-fx-cands-row]');
    var candsLabel = root.querySelector('[data-fx-cands-label]');
    var CANDS_FROM = 2, CANDS_MAX = window.matchMedia('(max-width: 1079.98px)').matches ? 5 : 8;
    function renderCands() {
      if (!cands) return;
      var qs = questions.filter(function (q) { return answers[q.id]; });
      if (qs.length < CANDS_FROM || root.classList.contains('is-done')) { cands.hidden = true; return; }
      if (poolState !== 2) { ensurePool(renderCands); return; }
      var hits;
      if (TREE) {
        hits = (TREE.cands[answers.need + '|' + answers.scene] || []).map(function (h) { return byHandle[h]; }).filter(function (p) { return p && !inCart[p.handle]; });
      } else {
        hits = rank().filter(function (p) { return fit(p) >= 0.62; });
        if (hits.length < 3) hits = rank().slice(0, 3);
      }
      candsLabel.innerHTML = 'いまの候補 <b>' + hits.length + '</b> 製品<span class="fx__cands-hint">' + (window.matchMedia('(hover: hover)').matches ? 'クリックで詳しく見られます' : 'タップで詳細') + '</span>';
      var keep = {};
      hits.slice(0, CANDS_MAX).forEach(function (p, i) {
        keep[p.handle] = true;
        var img = (safeJSON(cards[p.handle] && cards[p.handle].getAttribute('data-images')) || [])[0];
        var t = candsRow.querySelector('[data-h="' + p.handle + '"]');
        if (!t) {
          /* 途中でも選べる: PC はホバーで名前・価格・マッチ度、クリック/タップで詳細モーダル（そのままカートへ） */
          t = el('button', 'fx__cand', (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '<span class="fx__cand-pop" aria-hidden="true"><b></b><span class="fx__cand-meta"></span><small>クリックで詳しく</small></span>');
          t.type = 'button';
          t.setAttribute('data-h', p.handle);
          t.setAttribute('data-fx-cand', '');
        }
        t.setAttribute('aria-label', p.title + ' の詳細を見る');
        t.querySelector('.fx__cand-pop b').textContent = p.title;
        t.querySelector('.fx__cand-meta').innerHTML = yen(cardPrice(cards[p.handle])) + (TREE ? '' : '<em>マッチ度 ' + matchPct(p) + '%</em>');
        t.style.setProperty('--k', String(i));
        candsRow.appendChild(t);
      });
      Array.prototype.forEach.call(candsRow.querySelectorAll('[data-h]'), function (t) { if (!keep[t.getAttribute('data-h')]) t.remove(); });
      var more = candsRow.querySelector('.fx__cand-more');
      if (more) more.remove();
      if (hits.length > CANDS_MAX) candsRow.appendChild(el('span', 'fx__cand-more', '+' + (hits.length - CANDS_MAX)));
      cands.hidden = false;
    }
    function clearCands() { if (cands) { cands.hidden = true; candsRow.innerHTML = ''; } }

    /* ── 結果 ── */
    function cardPrice(c) {
      var vid = variants[c.getAttribute('data-handle')];
      var vs = safeJSON(c.getAttribute('data-variants')) || [];
      var v = vs.filter(function (x) { return String(x.id) === String(vid); })[0];
      return v ? v.p : parseInt(c.getAttribute('data-price'), 10) || 0;
    }
    function safeJSON(s) { try { return JSON.parse(s); } catch (e) { return null; } }
    function currentVariant(c) {
      var h = c.getAttribute('data-handle');
      if (!c.hasAttribute('data-fx-card')) return c.getAttribute('data-variant');
      return variants[h] || c.getAttribute('data-variant');
    }
    function syncBar() {
      var n = 0, total = 0;
      shown.forEach(function (p) {
        if (!picked[p.handle]) return;
        n++; total += cardPrice(cards[p.handle]);
      });
      countEl.textContent = n;
      totalEl.textContent = n ? '（合計 ' + yen(total) + '）' : '';
      addAll.disabled = n === 0;
      allBox.checked = shown.length > 0 && shown.every(function (p) { return picked[p.handle]; });
      shown.forEach(function (p) {
        var c = cards[p.handle];
        c.classList.toggle('is-picked', !!picked[p.handle]);
        c.querySelector('[data-fx-pick]').checked = !!picked[p.handle];
      });
      persist();
    }
    var shuffle = root.querySelector('[data-fx-shuffle]');
    function runShuffle(done) {
      if (!shuffle || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); return; }
      var pool = Object.keys(cards).map(function (h) { return (safeJSON(cards[h].getAttribute('data-images')) || [])[0]; }).filter(Boolean);
      var slots = shuffle.querySelectorAll('img');
      qWrap.hidden = true;
      result.hidden = true;
      shuffle.hidden = false;
      var t = 0;
      var iv = window.setInterval(function () {
        Array.prototype.forEach.call(slots, function (im, i) { im.src = pool[(t * 3 + i * 7) % pool.length]; });
        t++;
      }, 90);
      window.setTimeout(function () {
        window.clearInterval(iv);
        shuffle.hidden = true;
        done();
      }, 1100);
    }
    function showResult(instant) {
      if (poolState !== 2) { ensurePool(function () { showResult(instant); }); return; }
      if (!instant && !root.classList.contains('is-done')) { runShuffle(function () { showResult(true); result.classList.remove('is-instant'); }); return; }
      var ranked = pick3();
      if (!ranked.length) return;
      markSeen(ranked.slice(1));
      clearTrail();
      clearCands();
      qWrap.hidden = true;
      root.classList.add('is-done');
      shown = ranked;
      cardsWrap.innerHTML = '';
      var anyPick = ranked.some(function (p) { return picked[p.handle]; });
      if (!anyPick) picked[ranked[0].handle] = true;
      ranked.forEach(function (p, i) {
        var c = cards[p.handle];
        /* 10/9: ツリー（トップの診断）は「1・2・3」の連番。おすすめ度の言葉は付けない */
        c.querySelector('[data-fx-rank]').textContent = TREE ? String(i + 1) : RANK[i];
        c.classList.toggle('is-num', !!TREE);
        var mp = c.querySelector('[data-fx-match]');
        if (mp && TREE) { mp.innerHTML = ''; mp.hidden = true; }
        if (mp && !TREE) { mp.innerHTML = 'マッチ度 <b>' + matchPct(p) + '</b>%'; mp.style.setProperty('--pct', matchPct(p)); }
        /* 10/9: 価格の下のコピーはいったん出さない（BM と 1 つずつ設定していく運用にする） */
        var rs = c.querySelector('[data-fx-reason]');
        rs.textContent = TREE ? '' : reasonFor(p);
        rs.hidden = !!TREE;
        var tg = c.querySelector('[data-fx-tags]'); if (tg) tg.innerHTML = tagsFor(p);
        c.classList.toggle('is-top', i === 0);
        c.classList.toggle('is-discover', !TREE && i === 2);
        c.style.setProperty('--i', String(i));
        c.hidden = false;
        Array.prototype.forEach.call(c.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
        cardsWrap.appendChild(c);
      });
      /* 10/8: 3 件まるごと入れ替えられない答え（候補 5 件以下）では「ほかの候補も見る」を押せなくする */
      var reroll = root.querySelector('[data-fx-reroll]');
      if (reroll) {
        var more = TREE ? treeList().length >= 6 : true;  /* 3 件まるごと入れ替えられる組が 2 つ以上あるときだけ */
        reroll.disabled = !more;
        reroll.title = more ? '' : 'この答えで入れ替えられる候補がありません';
      }
      picksEl.innerHTML = '<span class="fx__picks-label">' + (restoredNote ? '前回の診断' : 'あなたの答え') + '</span>' +
        questions.filter(function (q) { return !(q.id === 'scene' && sceneSkipped()); }).map(function (q) { return '<span class="fx__chip">' + optionLabel(q.id, answers[q.id]) + '</span>'; }).join('');
      /* リード文は出さない（9/29 FB: 説明は不要。見出しと質問だけで伝わる） */
      if (lead) { lead.textContent = ''; lead.hidden = true; }
      result.hidden = false;
      result.classList.toggle('is-instant', !!instant);
      result.classList.remove('is-in'); void result.offsetWidth; result.classList.add('is-in');
      renderProgress(true);
      syncBar();
    }
    function reset() {
      treeOffset = 0;
      answers = {}; picked = {}; variants = {}; restoredNote = false;
      clearTrail();
      clearCands();
      drop(KEY);
      Array.prototype.forEach.call(qWrap.querySelectorAll('.fx__opt.is-on'), function (o) { o.classList.remove('is-on'); });
      Object.keys(cards).forEach(function (h) { cards[h].hidden = true; cards[h].classList.remove('is-picked', 'is-top'); });
      showPanel(0);
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    /* ── カート ── */
    var toastTimer = null;
    function showToast(html, ok) {
      toast.innerHTML = html;
      toast.classList.toggle('is-error', !ok);
      toast.hidden = false;
      toast.classList.remove('is-in'); void toast.offsetWidth; toast.classList.add('is-in');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.hidden = true; }, 5000);
    }
    function refreshCartCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (e) { e.textContent = cart.item_count; });
        Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count-bubble]'), function (e) {
          e.classList.toggle('hide', cart.item_count === 0);
          e.classList.remove('critical-hidden');
        });
      }).catch(function () {});
    }
    function addToCart(items, btn) {
      if (!items.length) return;
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description ? j.description : 'カートに入れられませんでした'); });
        return r.json();
      }).then(function (res) {
        refreshCartCount();
        var added = (res && res.items) || [];
        /* サイト標準のカートポップアップ（ヘッダー内・商品ページと同じ）を出す。無ければトースト */
        if (!sitePopup(added)) showToast('<b>' + items.length + ' 点をカートに入れました</b><a href="/cart">カートを見る<svg aria-hidden="true"><use href="#fx-arrow"></use></svg></a>', true);
        if (btn) { btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.innerHTML = '<svg aria-hidden="true"><use href="#fx-check"></use></svg>カートに入れました'; window.setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 1800); }
      }).catch(function (e) {
        showToast('<b>' + (e.message || 'カートに入れられませんでした') + '</b>', false);
        if (btn) { btn.classList.remove('is-busy'); btn.innerHTML = label; btn.disabled = false; }
      });
    }

    /* ── サイト標準のカートポップアップ（theme.js の Product が商品ページで出すものと同じ DOM を直接使う） ── */
    function sitePopup(added) {
      var wrap = document.querySelector('[data-cart-popup-wrapper]');
      if (!wrap || !added.length) return false;
      var first = added[0];
      var qty = added.reduce(function (a, it) { return a + (it.quantity || 1); }, 0);
      var q = function (sel) { return wrap.querySelector(sel); };
      if (!modal.hidden) closeModal();
      q('[data-cart-popup-title]').textContent = added.length > 1 ? first.product_title + ' ほか ' + (added.length - 1) + ' 点' : first.product_title;
      q('[data-cart-popup-quantity]').textContent = qty;
      var ql = q('[data-cart-popup-quantity-label]');
      if (ql && window.theme && theme.strings && theme.strings.quantityLabel) ql.textContent = theme.strings.quantityLabel.replace('[count]', qty);
      var det = q('[data-cart-popup-product-details]');
      if (det) det.innerHTML = added.length === 1 && !first.product_has_only_default_variant && first.options_with_values
        ? first.options_with_values.map(function (o) { return '<li class="product-details__item product-details__item--variant-option">' + o.name + ': ' + o.value + '</li>'; }).join('') : '';
      var iw = q('[data-cart-popup-image-wrapper]');
      if (iw) {
        var old = iw.querySelector('[data-cart-popup-image]'); if (old) old.remove();
        var src = first.featured_image && first.featured_image.url;
        iw.classList.toggle('hide', !src);
        if (src) {
          var im = new Image();
          im.alt = (first.featured_image && first.featured_image.alt) || '';
          im.className = 'cart-popup-item__image';
          im.setAttribute('data-cart-popup-image', '');
          im.onload = function () { iw.removeAttribute('data-image-loading-animation'); iw.appendChild(im); };
          im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        }
      }
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var cq = q('[data-cart-popup-cart-quantity]'); if (cq) cq.textContent = c.item_count;
      }).catch(function () {});
      wrap.classList.remove('critical-hidden', 'cart-popup-wrapper--hidden');
      var box = q('[data-cart-popup]'); if (box) box.focus({ preventScroll: true });
      if (!wrap.__fxBound) {
        wrap.__fxBound = true;
        var hide = function () { wrap.classList.add('cart-popup-wrapper--hidden'); };
        wrap.addEventListener('click', function (e) { if (e.target.closest('[data-cart-popup-close], [data-cart-popup-dismiss]')) hide(); });
        document.addEventListener('keyup', function (e) { if (e.key === 'Escape') hide(); });
        document.addEventListener('click', function (e) { if (!wrap.contains(e.target) && !e.target.closest('[data-fx-add], [data-fx-addall], [data-fx-m-add], [data-clab-add], [data-clab-addall]')) hide(); });
      }
      return true;
    }

    /* ── モーダル（SP は下から出るシート。つまみ・上端から下へスワイプで閉じる） ── */
    var mpanel = modal.querySelector('[data-fx-m-panel]') || modal.querySelector('.fx__modal-panel');
    var modalPushed = false;
    window.addEventListener('popstate', function () { if (!modal.hidden) closeModal(true); });
    (function () {
      var body = modal.querySelector('[data-fx-m-body]');
      var y0 = null, dy = 0, t0 = 0, active = false;
      function isSheet() { return !window.matchMedia('(min-width: 1080px)').matches; }
      mpanel.addEventListener('touchstart', function (e) {
        if (!isSheet() || e.touches.length !== 1) return;
        var onGrip = e.target.closest('[data-fx-m-grip], .fx__modal-close');
        var atTop = !body || body.scrollTop <= 0;
        /* 画像の横スワイプ中は奪わない */
        if (!onGrip && (!atTop || e.target.closest('[data-fx-m-strip], [data-fx-m-thumbs]'))) return;
        y0 = e.touches[0].clientY; dy = 0; t0 = Date.now(); active = false;
      }, { passive: true });
      mpanel.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        dy = e.touches[0].clientY - y0;
        if (!active && dy > 6) { active = true; mpanel.classList.add('is-drag'); }
        if (!active) { if (dy < 0) y0 = null; return; }
        if (e.cancelable) e.preventDefault();
        mpanel.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
        modal.style.setProperty('--fx-dim', String(Math.max(0, 1 - dy / (mpanel.offsetHeight || 600))));
      }, { passive: false });
      function end() {
        if (y0 === null) return;
        y0 = null;
        mpanel.classList.remove('is-drag');
        if (!active) return;
        var v = dy / Math.max(1, Date.now() - t0);
        if (dy > Math.min(160, mpanel.offsetHeight * 0.25) || v > 0.6) { closeModal(); }
        else { mpanel.style.transform = ''; modal.style.removeProperty('--fx-dim'); }
        active = false;
      }
      mpanel.addEventListener('touchend', end);
      mpanel.addEventListener('touchcancel', end);
    })();
    var lastFocus = null;
    var modalCard = null;
    function openModal(c) {
      modalCard = c;
      lastFocus = document.activeElement;
      var h = c.getAttribute('data-handle');
      var p = byHandle[h] || {};
      var imgs = safeJSON(c.getAttribute('data-images')) || [];
      var vs = safeJSON(c.getAttribute('data-variants')) || [];
      var thumbs = modal.querySelector('[data-fx-m-thumbs]');
      modal.querySelector('[data-fx-m-cat]').textContent = c.getAttribute('data-cat') || '';
      /* 製品名・画像も製品ページへ（押しても動かないクリックが多かったため） */
      var mUrl = c.getAttribute('data-url');
      var mName = modal.querySelector('[data-fx-m-name]');
      mName.textContent = '';
      var nameLink = document.createElement('a');
      nameLink.className = 'fx__modal-name-link';
      nameLink.href = mUrl;
      nameLink.textContent = c.getAttribute('data-name') || '';
      mName.appendChild(nameLink);
      /* 価格はカードの表示（割引率・取り消し線込み）をそのまま使う。カラーのカードは .product-price-v2 */
      var priceSrc = c.querySelector('.fx__price') || c.querySelector('.product-price-v2');
      var rateEl = priceSrc && priceSrc.parentNode && priceSrc.parentNode.querySelector('.product-price-v2-discount-rate');
      if (priceSrc && !priceSrc.classList.contains('fx__price')) { priceSrc = priceSrc.cloneNode(true); priceSrc.classList.add('fx__price'); }
      modal.querySelector('[data-fx-m-price]').innerHTML = (rateEl ? rateEl.outerHTML : '') + (priceSrc ? priceSrc.outerHTML : '<div class="fx__price product-price-v2"><span class="product-price-v2-default">' + yen(parseInt(c.getAttribute('data-price'), 10) || 0) + '</span><span class="product-price-v2-tax">（税込）</span></div>');
      /* レビュー（製品詳細ページと同じ星・件数。押すとレビュー欄へ） */
      var rt = parseFloat(c.getAttribute('data-rt')) || 0, rc = parseInt(c.getAttribute('data-rc'), 10) || 0;
      var rEl = modal.querySelector('[data-fx-m-rating]');
      rEl.hidden = !(rt > 0 && rc > 0);
      if (!rEl.hidden) {
        rEl.href = mUrl + '#leeep-tag-review-title';
        rEl.setAttribute('aria-label', '評価 ' + rt.toFixed(1) + '（レビュー ' + rc + ' 件）');
        modal.querySelector('[data-fx-m-stars]').style.width = Math.min(100, rt / 5 * 100) + '%';
        modal.querySelector('[data-fx-m-rt]').textContent = rt.toFixed(1);
        modal.querySelector('[data-fx-m-rc]').textContent = '（' + rc + '件）';
      }
      /* 注記（※…）は特長に出さない */
      var pts = (p.points && p.points.length ? p.points : (safeJSON(c.getAttribute('data-points')) || [])).filter(function (t) { return t && !/^\s*[※*]/.test(t); });
      modal.querySelector('[data-fx-m-points]').innerHTML = pts.map(function (t) { return '<li><svg aria-hidden="true"><use href="#fx-check"></use></svg>' + t + '</li>'; }).join('');
      modal.querySelector('[data-fx-m-link]').href = mUrl;
      var cur = String(currentVariant(c));
      var curV = vs.filter(function (v) { return String(v.id) === cur; })[0];
      thumbs.innerHTML = '';
      var list = [];
      /* 選択中の色 → 他の色の順で variant 画像を先頭に、続けて製品の画像。重複は除く */
      if (curV && curV.img) list.push(curV.img);
      vs.forEach(function (v) { if (v.img && list.indexOf(v.img) === -1) list.push(v.img); });
      imgs.forEach(function (src) { if (list.indexOf(src) === -1) list.push(src); });
      var strip = modal.querySelector('[data-fx-m-strip]');
      strip.innerHTML = '';
      list.forEach(function (src, i) {
        var t = el('button', 'fx__modal-thumb', '<img src="' + src + '" alt="" loading="lazy">');
        t.type = 'button'; t.setAttribute('data-src', src); t.setAttribute('aria-label', (i + 1) + ' 枚目');
        t.addEventListener('click', function () { setMain(src); });
        thumbs.appendChild(t);
        var f = el('a', 'fx__modal-frame', '<img src="' + src + '" alt="" draggable="false" loading="' + (i < 2 ? 'eager' : 'lazy') + '">');
        f.href = mUrl; f.tabIndex = -1; f.draggable = false;
        f.setAttribute('aria-label', (c.getAttribute('data-name') || '') + ' の製品ページ');
        f.setAttribute('data-src', src);
        strip.appendChild(f);
      });
      var counter = modal.querySelector('[data-fx-m-counter]');
      var twrap = modal.querySelector('[data-fx-m-thumbwrap]');
      function syncThumbEdges() {
        if (!twrap) return;
        var more = thumbs.scrollWidth - thumbs.clientWidth - thumbs.scrollLeft;
        twrap.classList.toggle('has-more', more > 4);
        twrap.classList.toggle('has-prev', thumbs.scrollLeft > 4);
        var mb = twrap.querySelector('[data-fx-m-more]');
        if (mb) { var idx = Math.round(thumbs.scrollLeft / 72); var rest = Math.max(0, list.length - Math.floor((thumbs.scrollLeft + thumbs.clientWidth) / 72)); mb.textContent = rest ? '+' + rest : ''; }
      }
      thumbs.onscroll = syncThumbEdges;
      var moreBtn = modal.querySelector('[data-fx-m-more]');
      if (moreBtn) moreBtn.onclick = function () { thumbs.scrollBy({ left: thumbs.clientWidth - 72, behavior: 'smooth' }); };
      var prevBtn = modal.querySelector('[data-fx-m-prev]');
      if (prevBtn) prevBtn.onclick = function () { thumbs.scrollBy({ left: -(thumbs.clientWidth - 72), behavior: 'smooth' }); };
      window.setTimeout(syncThumbEdges, 50);
      function setMain(src) {
        var idx = list.indexOf(src); if (idx < 0) idx = 0;
        strip.scrollTo({ left: strip.clientWidth * idx, behavior: 'auto' });
        Array.prototype.forEach.call(thumbs.children, function (t, i) { t.classList.toggle('is-on', i === idx); if (i === idx && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
        if (counter) counter.textContent = (idx + 1) + ' / ' + list.length;
      }
      modal.__list = list;
      modal.__go = function (d) { var i = Math.round(strip.scrollLeft / (strip.clientWidth || 1)) + d; if (i < 0 || i >= list.length) return; strip.scrollTo({ left: strip.clientWidth * i, behavior: 'smooth' }); };
      modal.__idx = function () { return Math.round(strip.scrollLeft / (strip.clientWidth || 1)); };
      function syncNav(idx) {
        var pv = modal.querySelector('[data-fx-m-sprev]'), nx = modal.querySelector('[data-fx-m-snext]');
        if (pv) pv.hidden = idx <= 0; if (nx) nx.hidden = idx >= list.length - 1;
      }
      syncNav(0);
      strip.onscroll = function () {
        var idx = Math.round(strip.scrollLeft / strip.clientWidth);
        syncNav(idx);
        Array.prototype.forEach.call(thumbs.children, function (t, i) { t.classList.toggle('is-on', i === idx); });
        if (counter) counter.textContent = (idx + 1) + ' / ' + list.length;
      };
      setMain(curV && curV.img ? curV.img : list[0] || '');
      var vwrap = modal.querySelector('[data-fx-m-variants]');
      var vlist = modal.querySelector('[data-fx-m-vlist]');
      vlist.innerHTML = '';
      var colorVs = vs.filter(function (v) { return v.t && v.t !== 'Default Title'; });
      if (colorVs.length > 1) {
        vwrap.hidden = false;
        colorVs.forEach(function (v) {
          /* 製品詳細ページと同じく、色は画像で選ぶ。在庫切れは斜線（画像が無い型は文字のボタン） */
          var b = el('button', 'fx__variant' + (v.img ? ' fx__variant--img' : '') + (String(v.id) === cur ? ' is-on' : '') + (v.a ? '' : ' is-soldout'),
            v.img ? '<img src="' + v.img.replace(/([?&]width=)\d+/, '$1160') + '" alt="" loading="lazy">' : v.t + (v.a ? '' : '<small>在庫切れ</small>'));
          b.type = 'button';
          b.setAttribute('aria-label', v.t + (v.a ? '' : '（在庫切れ）'));
          b.title = v.t + (v.a ? '' : '（在庫切れ）');
          if (!v.a) b.setAttribute('aria-disabled', 'true');
          b.addEventListener('click', function () {
            if (!v.a) return;
            showVariant(v);
            variants[h] = v.id;
            if (!c.hasAttribute('data-fx-card')) c.setAttribute('data-variant', v.id);
            Array.prototype.forEach.call(vlist.children, function (x) { x.classList.toggle('is-on', x === b); });
            if (v.img) setMain(v.img);
            setLinks(v.id);
            syncBar();
          });
          vlist.appendChild(b);
        });
      } else {
        vwrap.hidden = true;
      }
      /* 製品型番・選択中の色・発送予定（製品詳細ページと同じ並び） */
      /* 価格は選択中の色の金額だけ（「〜」を付けない）。割引率は product-price-v2-discount-rate と同じ式
         （100 − 価格×100÷元値 を四捨五入）。色ごとの元値が無いのにカードがセール表示＝タグ・メタフィールド割引のときはカードの表示のまま */
      var cardPriceHTML = modal.querySelector('[data-fx-m-price]').innerHTML;
      var varCompare = vs.some(function (x) { return x.c && x.c > x.p; });
      function yenHTML(n) { return '<span class="product-price-v2-yen">¥</span>' + Math.round(n / 100).toLocaleString('ja-JP'); }
      function renderPrice(v) {
        var box = modal.querySelector('[data-fx-m-price]');
        if (!v || !v.p || (!varCompare && /product-price-v2-sale/.test(cardPriceHTML))) {
          box.innerHTML = cardPriceHTML;
          Array.prototype.forEach.call(box.querySelectorAll('.product-price-v2'), function (el) {
            Array.prototype.forEach.call(el.childNodes, function (n) { if (n.nodeType === 3 && /~|〜/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/[~〜]/g, ''); });
          });
          return;
        }
        var sale = v.c && v.c > v.p;
        box.innerHTML = (sale ? '<p class="product-price-v2-discount-rate">' + Math.round(100 - v.p * 100 / v.c) + '%OFF</p>' : '') +
          '<div class="product-price-v2 fx__price">' +
          (sale ? '<div class="product-price-v2-sale-wrap"><p class="product-price-v2-sale">' + yenHTML(v.c) + '</p><p class="product-price-v2-default">' + yenHTML(v.p) + '</p></div>'
                : '<p class="product-price-v2-default">' + yenHTML(v.p) + '</p>') +
          '<span class="product-price-v2-tax">（税込）</span></div>';
      }
      function showVariant(v) {
        renderPrice(v);
        var sku = modal.querySelector('[data-fx-m-sku]');
        var label = v && v.t && v.t !== 'Default Title' ? v.t : '';
        sku.hidden = !(v && (v.s || label));
        if (!sku.hidden) modal.querySelector('[data-fx-m-skuv]').textContent = ((v.s || '') + ' ' + label).trim();
        var vn = modal.querySelector('[data-fx-m-vname]'); if (vn) vn.textContent = label;
        var ship = modal.querySelector('[data-fx-m-ship]');
        var st = v && v.a !== false && !c.hasAttribute('data-noship') && modal.__notesFailed ? shipText(ship.getAttribute('data-delivery')) : '';
        if (modal.__notesInput && v) { modal.__notesInput.value = v.id; if (modal.__setMile) try { modal.__setMile(); } catch (e) {} }
        ship.hidden = !st; ship.querySelector('span').textContent = st;
      }
      loadNotes(c, mUrl, function () { showVariant(curV || vs[0] || null); });
      showVariant(curV || vs[0] || null);
      /* 製品名・画像・「製品ページで詳しく見る」は選択中の色の製品ページへ */
      function setLinks(id) {
        var u = mUrl + (colorVs.length > 1 && id ? (mUrl.indexOf('?') < 0 ? '?' : '&') + 'variant=' + id : '');
        Array.prototype.forEach.call(modal.querySelectorAll('.fx__modal-name-link, a.fx__modal-frame, [data-fx-m-link]'), function (a) { a.href = u; });
      }
      setLinks(cur);
      modal.hidden = false;
      document.documentElement.classList.add('fx-modal-open');
      var mbody = modal.querySelector('[data-fx-m-body]'); if (mbody) mbody.scrollTop = 0;
      mpanel.style.transform = ''; modal.style.removeProperty('--fx-dim');
      void mpanel.offsetWidth;
      window.requestAnimationFrame(function () { modal.classList.add('is-in'); });
      /* ブラウザの「戻る」でシートを閉じる（アプリと同じ感覚に） */
      if (!(history.state && history.state.fxModal)) { try { history.pushState({ fxModal: 1 }, ''); modalPushed = true; } catch (e) {} }
      modal.querySelector('[data-fx-modal-close]:not(.fx__modal-backdrop)').focus();
    }
    /* 製品詳細ページの注記（獲得マイル・送料無料・発送予定・クーポン併用不可など）を製品詳細ページと同じ snippet で取ってきて差し込む。
       注記の script は製品ページの DOM（#product-form の id・#product-mile）を前提にしているので、ポップアップの中だけを見る document を渡して動かす */
    var notesCache = {};
    function loadNotes(c, url, done) {
      var box = modal.querySelector('[data-fx-m-notes]');
      if (!box) return;
      box.innerHTML = ''; modal.__setMile = null; modal.__notesInput = null; modal.__notesFailed = false;
      if (!document.querySelector('link[data-fx-notes-css]') && box.getAttribute('data-css')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = box.getAttribute('data-css'); l.setAttribute('data-fx-notes-css', ''); document.head.appendChild(l);
      }
      var h = c.getAttribute('data-handle');
      var src = url.split('?')[0] + '?view=fx-notes';
      (notesCache[h] || (notesCache[h] = fetch(src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.text(); })))
        .then(function (html) {
          if (modalCard !== c) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var wrap = tmp.querySelector('[data-fx-notes]'); if (!wrap) throw new Error('no notes');
          var codes = Array.prototype.map.call(wrap.querySelectorAll('script'), function (s) { var t = s.textContent; s.remove(); return t; });
          /* アイコンの mask / gradient の id がヘッダーの同じアイコン（非表示）と重なると塗りつぶしの四角になるので、id を付け替える */
          var html2 = wrap.innerHTML, ids = {};
          html2.replace(/\sid="([^"]+)"/g, function (m, id) { ids[id] = 1; return m; });
          Object.keys(ids).forEach(function (id) {
            if (/^product-|^discount-rate/.test(id)) return;
            html2 = html2.split('id="' + id + '"').join('id="fxn-' + id + '"').split('url(#' + id + ')').join('url(#fxn-' + id + ')').split('url("#' + id + '")').join('url("#fxn-' + id + '")').split('href="#' + id + '"').join('href="#fxn-' + id + '"');
          });
          box.innerHTML = html2;
          var input = document.createElement('input'); input.name = 'id'; input.value = currentVariant(c);
          modal.__notesInput = input;
          var doc = new Proxy(document, { get: function (t, k) {
            if (k === 'getElementById') return function (id) { return box.querySelector('#' + CSS.escape(id)); };
            if (k === 'querySelector') return function (sel) { return /#product-form/.test(sel) ? input : box.querySelector(sel); };
            if (k === 'querySelectorAll') return function (sel) { return box.querySelectorAll(sel); };
            if (k === 'addEventListener' || k === 'removeEventListener') return function () {};
            var v = t[k]; return typeof v === 'function' ? v.bind(t) : v;
          } });
          codes.forEach(function (code) {
            try {
              var fn = new Function('document', code + '\n;return typeof setMile === "function" ? setMile : null;');
              var sm = fn(doc); if (sm) modal.__setMile = sm;
            } catch (e) {}
          });
          var dd = box.querySelector('.global-delivery-date');
          if (dd) dd.textContent = shipText(modal.querySelector('[data-fx-m-ship]').getAttribute('data-delivery'));
          if (modal.__setMile) try { modal.__setMile(); } catch (e) {}
          done && done();
        })
        .catch(function () { delete notesCache[h]; if (modalCard !== c) return; modal.__notesFailed = true; done && done(); });
    }
    function closeModal(fromPop) {
      if (modal.hidden) return;
      zoomClose();
      modal.classList.remove('is-in');
      mpanel.style.transform = ''; modal.style.removeProperty('--fx-dim');
      document.documentElement.classList.remove('fx-modal-open');
      window.setTimeout(function () { if (!modal.classList.contains('is-in')) modal.hidden = true; }, 380);
      if (modalPushed && fromPop !== true) { modalPushed = false; try { history.back(); } catch (e) {} }
      modalPushed = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      modalCard = null;
    }

    root.__fxApi.openModal = openModal;
    /* 検証用: 候補プールと推定値を丸ごと返す（社内レビュー資料の生成用） */
    root.__fxApi.dump = function (cb) {
      ensurePool(function () {
        cb(products.map(function (p) {
          return { h: p.handle, title: p.title, cat: p.cat, need: p.need, crank: p.crank, price: p.price, launchMo: p.launchMo, isNew: p.isNew, rc: p.rc,
            scene: p.feat.scene, pri: p.feat.pri, prior: Math.round(prior(p) * 100) / 100, ai: !!labels[p.handle], why: p.why || '', reason: p.reason || '', spec: specText(p) };
        }), Object.keys(poolEl.querySelectorAll('[data-fx-card]')).length);
      });
    };
    /* 検証用: 答えを与えて 3 つを引く（画面は変えない） */
    root.__fxApi.simulate = function (ans, cb) {
      ensurePool(function () {
        var keep = answers; answers = ans;
        var r = pick3().map(function (p) { return { h: p.handle, cat: p.cat, need: p.need, fit: Math.round(fit(p) * 100), title: p.title }; });
        answers = keep; cb(r, products.length);
      });
    };
    root.__fxApi.addToCart = addToCart;
    window.v2FinderV2.openModal = openModal;
    window.v2FinderV2.addToCart = addToCart;

    /* ── イベント ── */
    root.addEventListener('click', function (e) {
      var cand = e.target.closest('[data-fx-cand]');
      if (cand && cards[cand.getAttribute('data-h')]) { openModal(cards[cand.getAttribute('data-h')]); return; }
      var opt = e.target.closest('.fx__opt');
      if (opt && qWrap.contains(opt)) { onOption(opt); return; }
      if (e.target.closest('[data-fx-back]')) {
        var prev = Math.max(current - 1, 0);
        if (prev > 0 && questions[prev].id === 'scene' && sceneSkipped()) { delete answers.scene; prev--; }
        delete answers[questions[prev].id];
        showPanel(prev);
        renderCands();
        return;
      }
      if (e.target.closest('[data-fx-reset]')) { reset(); return; }
      if (e.target.closest('[data-fx-reroll]')) {
        treeOffset++;
        Object.keys(cards).forEach(function (h) { cards[h].hidden = true; });
        picked = {};
        showResult(true);
        result.classList.remove('is-instant'); void result.offsetWidth; result.classList.add('is-in');
        return;
      }
      var card = e.target.closest('[data-fx-card]');
      if (card) {
        if (e.target.closest('[data-fx-add]')) { addToCart([{ id: parseInt(currentVariant(card), 10), quantity: 1 }], e.target.closest('[data-fx-add]')); return; }
        /* カードのタップは詳細モーダル（「詳しく見る」ボタンは廃止。選択チェックとカートボタンは除く）。
           名前のリンクも同じくモーダルに（新しいタブ・長押しは製品ページのまま） */
        if (!e.target.closest('.fx__pick, [data-fx-pick]')) {
          if (e.target.closest('a') && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
          e.preventDefault();
          openModal(card);
          return;
        }
      }
      if (e.target.closest('[data-fx-addall]')) {
        var items = shown.filter(function (p) { return picked[p.handle]; }).map(function (p) { return { id: parseInt(currentVariant(cards[p.handle]), 10), quantity: 1 }; });
        addToCart(items, addAll);
        return;
      }
    });
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fx-modal-close]')) { closeModal(); return; }
      if (e.target.closest('[data-fx-m-add]') && modalCard) {
        addToCart([{ id: parseInt(currentVariant(modalCard), 10), quantity: 1 }], e.target.closest('[data-fx-m-add]'));
        return;
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-fx-pick]')) {
        var c = e.target.closest('[data-fx-card]');
        picked[c.getAttribute('data-handle')] = e.target.checked;
        syncBar();
      } else if (e.target === allBox) {
        shown.forEach(function (p) { picked[p.handle] = allBox.checked; });
        syncBar();
      }
    });
    /* ── 画像の拡大（製品詳細ページのルーペと同じ役割。PC はクリックで 2 倍、マウスで動かす。スマホはピンチ） ── */
    var zoom = zoomEl, zIdx = 0;
    function zoomSrc(src) { return src.replace(/([?&]width=)\d+/, '$11800'); }
    function zoomShow(i) {
      var list = modal.__list || []; if (!list.length) return;
      zIdx = (i + list.length) % list.length;
      var view = zoom.querySelector('[data-fx-zoom-view]'); view.classList.remove('is-zoomed');
      zoom.querySelector('[data-fx-zoom-img]').src = zoomSrc(list[zIdx]);
      zoom.querySelector('[data-fx-zoom-counter]').textContent = (zIdx + 1) + ' / ' + list.length;
      zoom.querySelector('[data-fx-zoom-prev]').hidden = zoom.querySelector('[data-fx-zoom-next]').hidden = list.length < 2;
    }
    function zoomOpen() { if (!zoom) return; zoomShow(modal.__idx ? modal.__idx() : 0); zoom.hidden = false; document.documentElement.classList.add('fx-zoom-open'); zoom.querySelector('[data-fx-zoom-close]').focus(); }
    function zoomClose() {
      if (!zoom || zoom.hidden) return;
      zoom.hidden = true; document.documentElement.classList.remove('fx-zoom-open');
      var strip = modal.querySelector('[data-fx-m-strip]'); if (strip) strip.scrollTo({ left: strip.clientWidth * zIdx, behavior: 'auto' });
      var zb = modal.querySelector('[data-fx-m-zoom]'); if (zb) zb.focus();
    }
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-fx-m-sprev]')) { modal.__go && modal.__go(-1); return; }
      if (e.target.closest('[data-fx-m-snext]')) { modal.__go && modal.__go(1); return; }
      if (e.target.closest('[data-fx-m-zoom]')) { zoomOpen(); }
    });
    if (zoom) {
      var zview = zoom.querySelector('[data-fx-zoom-view]');
      zoom.addEventListener('click', function (e) {
        if (e.target.closest('[data-fx-zoom-close]')) { zoomClose(); return; }
        if (e.target.closest('[data-fx-zoom-prev]')) { zoomShow(zIdx - 1); return; }
        if (e.target.closest('[data-fx-zoom-next]')) { zoomShow(zIdx + 1); return; }
        if (e.target.closest('[data-fx-zoom-img]') && window.matchMedia('(hover: hover)').matches) { zview.classList.toggle('is-zoomed'); setOrigin(e); return; }
        if (e.target === zview || e.target === zoom) zoomClose();
      });
      function setOrigin(e) {
        var r = zview.getBoundingClientRect();
        zview.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        zview.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      }
      zview.addEventListener('mousemove', function (e) { if (zview.classList.contains('is-zoomed')) setOrigin(e); });
    }
    document.addEventListener('keydown', function (e) {
      if (zoom && !zoom.hidden) {
        if (e.key === 'Escape') zoomClose();
        else if (e.key === 'ArrowLeft') zoomShow(zIdx - 1);
        else if (e.key === 'ArrowRight') zoomShow(zIdx + 1);
        return;
      }
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    /* ── 起動 ── */
    buildQuestions();
    /* 選択肢の絵の動き（SVG・無限ループ）は画面外では止める。SVG の動きは毎フレームのレイアウトを伴い、
       画面外でも読み込み中のスマホの処理を取っていた（2026-10 計測）。見えている間は従来どおり動く */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-offscreen', !entries[entries.length - 1].isIntersecting);
      }).observe(root);
    }
    /* 先読みはページの読み込みが終わってからアイドル時に（読み込み中の帯域・CPU を取り合わない）。選択肢を押したらその場で取りに行く */
    (function () {
      var go = function () { ('requestIdleCallback' in window) ? window.requestIdleCallback(function () { ensurePool(); }, { timeout: 4000 }) : window.setTimeout(ensurePool, 1500); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    })();
    if (treeUrl) {
      showPanel(0);
      ensureTree(function () {
        if (!TREE || !restore()) return;
        restoredNote = true;
        rebuildScene();
        ['need', 'scene', 'priority'].forEach(function (id) {
          var b = qWrap.querySelector('[data-q="' + id + '"][data-val="' + answers[id] + '"]');
          if (b) b.classList.add('is-on');
        });
        showResult(true);
      });
    } else if (restore()) {
      restoredNote = true;
      rebuildScene();
      questions.forEach(function (q) {
        var b = qWrap.querySelector('[data-q="' + q.id + '"][data-val="' + answers[q.id] + '"]');
        if (b) b.classList.add('is-on');
      });
      showResult(true);
    } else {
      showPanel(0);
    }
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get('finder_restore') === data.category) window.setTimeout(function () { root.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 150);
    } catch (e) {}
  }

  window.v2FinderV2 = { init: init };
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-fx]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
